import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Dropdown from "components/Dropdown";
import TitledContainer, { StaticText } from "components/TitledContainer";
import Translate from "utils/translate";

import styles from "./TitledRange.css";

const { t } = new Translate();

export default class TitledRange extends React.Component {
  constructor(props) {
    super(props);
    const { from, to, unit } = props;
    this.state = {
      from,
      to,
      unit,
      focus: false,
    };

    this.handleFromInput = this.handleFromInput.bind(this);
    this.handleToInput = this.handleToInput.bind(this);
    this.handleUnitSelect = this.handleUnitSelect.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
    if (!nextProps.isEdit) {
      this.setState({ focus: false });
    }
  }

  handleEdit() {
    const { onEdit } = this.props;
    this.setState({ focus: true });
    if (onEdit) onEdit();
  }

  handleFromInput({ target: { value } }) {
    const { onFromInput } = this.props;
    if (value.match(/^$|[0-9.,]+$/)) {
      this.setState({ from: value });
      onFromInput(value);
    }
  }

  handleToInput({ target: { value } }) {
    const { onToInput } = this.props;
    if (value.match(/^$|[0-9.,]+$/)) {
      this.setState({ to: value });
      onToInput(value);
    }
  }

  handleUnitSelect(val) {
    this.setState({ unit: val });
    this.props.onUnitSelect(val);
  }

  render() {
    const { from, isEdit, isRequired, separator, title, to, unit, unitSeparator, unitSize, units } =
      this.props;

    const isRange = from.toString() !== to.toString();
    const valueExtractor = (u) => t(`units.${u}`, unitSeparator ? 1 : 2);

    return (
      <TitledContainer
        isEdit={isEdit}
        isEmpty={!this.state.from || !this.state.to || !this.state.unit}
        onEdit={this.handleEdit}
        title={title}
        isEditable
      >
        <div
          className={cx(styles.wrapper, {
            [styles.edit]: isEdit,
          })}
        >
          <div className={styles.range}>
            {isEdit ? (
              <input
                autoFocus={this.state.focus}
                className={cx({
                  [styles.editable]: isEdit,
                  [styles.required]: isRequired && !this.state.from,
                })}
                onChange={this.handleFromInput}
                readOnly={!isEdit}
                size={7}
                type="text"
                value={from}
              />
            ) : (
              isRange && <StaticText text={from} isImportant />
            )}
          </div>
          {(isEdit || isRange) && <div className={styles.separator}>{separator}</div>}
          <div className={styles.range}>
            {isEdit ? (
              <input
                className={cx({
                  [styles.editable]: isEdit,
                  [styles.required]: isRequired && !this.state.to,
                })}
                onChange={this.handleToInput}
                readOnly={!isEdit}
                size={7}
                type="text"
                value={to}
              />
            ) : (
              <StaticText text={to} isImportant />
            )}
          </div>
          {unitSeparator && <div className={styles.separator}>{unitSeparator}</div>}
          <div className={cx(styles.unit, { [styles.padded]: !unitSeparator })}>
            {isEdit ? (
              <Dropdown
                inputComponentProps={{
                  isRequired: isRequired && !this.state.unit,
                  size: unitSize,
                }}
                inputValueExtractor={valueExtractor}
                onChange={this.handleUnitSelect}
                selectedValues={unit ? [unit] : []}
                valueExtractor={(v) => ({ label: valueExtractor(v) })}
                values={units}
              />
            ) : (
              <span>{unit && valueExtractor(unit)}</span>
            )}
          </div>
        </div>
      </TitledContainer>
    );
  }
}

TitledRange.propTypes = {
  title: PropTypes.string,
  from: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  separator: PropTypes.string.isRequired,
  to: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unit: PropTypes.string,
  units: PropTypes.arrayOf(PropTypes.string).isRequired,
  unitSize: PropTypes.number,
  unitSeparator: PropTypes.string,
  isEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  onEdit: PropTypes.func,
  onFromInput: PropTypes.func,
  onToInput: PropTypes.func,
  onUnitSelect: PropTypes.func,
};

TitledRange.defaultProps = {
  to: "",
  from: "",
};
